<ion-card class="card-grey" [class.chargeEmpty]="!chargePoints?.length" [class.viewMinimal]="displayMode === 'minimal'" [class.ghost]="ghostMode">
    <ion-card-content [class.viewMinimal]="displayMode === 'minimal'">
        <ng-container *ngIf="chargePoints?.length > 0; else noResultBlock">
            <ion-item class="plugPath charge" *ngFor="let chargePoint of chargePoints; trackBy: trackById"
                      tappable
                      (click)="selectChargePoint(chargePoint)"
                      [class.selected]="itemActions.length === 0 && isSelected(chargePoint)"
                      [class.viewMinimal]="displayMode === 'minimal'">
                <ion-row class="charge-container ion-align-items-center">
                    <ion-col size="3">
                        <div class="ghost-remote-img" [hidden]="!ghostMode"></div>
                        <img class="chargeCar" src="assets/images/svg/car-charge.svg" alt="" [hidden]="!isCableRequired(chargePoint) || ghostMode">
                        <img class="chargeStation" src="assets/images/svg/station-charge.svg" alt="" [hidden]="isCableRequired(chargePoint) || ghostMode">
                    </ion-col>
                    <ion-col [size]="canUseOneItemActions(chargePoint) ? 7 : 9">
                        <ion-label class="charge-label medium-ghost-size">
                            <span class="ghost-hidden">{{chargePoint | stationChargePoint}}</span></ion-label>
                        <ion-label class="charge-kW medium-ghost-size">
                            <span class="ghost-hidden">{{chargePoint.maxPowerInW | powerMaxInWToKw}}</span>
                        </ion-label>
                        <ion-label class="charge-kW lastUsageDate medium-ghost-size" *ngIf="!!chargePoint.lastUsageDate">
                            <span class="ghost-hidden">{{'charge.chargePointChoice.lastUsageDate' |
                                translate:{lastUsageDate: chargePoint.lastUsageDate | date:'mediumDate'} }}</span>
                        </ion-label>
                    </ion-col>
                    <ion-col size="2" *ngIf="canUseOneItemActions(chargePoint)" class="small-ghost-size col-img">
                        <ng-container *ngFor="let itemAction of itemActions; trackBy: trackByActionName">
                            <ion-fab *ngIf="!ghostMode && itemAction.canUse(chargePoint)">
                                <izivia-fab-button-with-loader (izivia-click)="doAction(itemAction.actionName, chargePoint)"
                                                               [icon]="itemAction.icon"
                                                               [disabled]="disabledAction"
                                                               [waiting]="chargePointIdWithPendingAction === chargePoint.id">
                                </izivia-fab-button-with-loader>
                            </ion-fab>
                        </ng-container>
                    </ion-col>
                </ion-row>
            </ion-item>
        </ng-container>
    </ion-card-content>
</ion-card>

<ng-template #noResultBlock>
    <div>
        <ion-item>{{'charge.chargePointChoice.noChoice' | translate}}</ion-item>
    </div>
</ng-template>
